import { RolesEnum } from '../../modules/general/users/core/enums/roles.enum'

const ROLE_PRIORITY: RolesEnum[] = [
	RolesEnum.superAdmin,
	RolesEnum.superManager,
	RolesEnum.manager,
	RolesEnum.marketing,
]

export function getPrimaryRole(roles: RolesEnum[] | undefined): RolesEnum | undefined {
	if (!roles?.length) return undefined
	return ROLE_PRIORITY.find(r => roles.includes(r))
}
